module.exports = __webpack_public_path__ + "static/media/placeholder.be2844e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/Placeholder/placeholder.png
// module id = 123
// module chunks = 0